module.exports = __webpack_public_path__ + "media/images/locations/sm/losangels-be9a6856d203c1ed9bdd006c03f0016a.jpg";